import { render } from "./wizardNuevoSeguro.vue?vue&type=template&id=669a3ba6"
import script from "./wizardNuevoSeguro.vue?vue&type=script&lang=js"
export * from "./wizardNuevoSeguro.vue?vue&type=script&lang=js"

import "./wizardNuevoSeguro.vue?vue&type=style&index=0&id=669a3ba6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__